var _a, _b;
import DeviceDetector from "device-detector-js";
const deviceDetector = new DeviceDetector();
const detector = deviceDetector.parse(navigator.userAgent);
export const isDesktop = !!(((_a = detector.device) === null || _a === void 0 ? void 0 : _a.type) === "desktop");
export const isTablet = !!(((_b = detector.device) === null || _b === void 0 ? void 0 : _b.type) === "tablet");
